<script setup lang="ts">
import ComfortIcon from "@/assets/icons/programs/comfort.svg?component";
import EcoIcon from "@/assets/icons/programs/eco.svg?component";
import FrostIcon from "@/assets/icons/programs/frost.svg?component";
import OnIcon from "@/assets/icons/programs/on.svg?component";
import TempIcon from "@/assets/icons/programs/temperature.svg?component";
import {
  EOnProgramMetaMode,
  EHeaterProgramMetaMode,
  TProgramMetaMode,
  ECommonProgramMetaMode,
} from "@/domains/v4b/program/subprogram.types";

interface IProps {
  mode: TProgramMetaMode;
}

const props = defineProps<IProps>();
</script>

<template>
  <div class="flex items-center">
    <ComfortIcon v-if="props.mode === EHeaterProgramMetaMode.COMFORT" />
    <EcoIcon v-else-if="props.mode === EHeaterProgramMetaMode.ECO" />
    <TempIcon v-else-if="props.mode === ECommonProgramMetaMode.TEMP" />
    <FrostIcon v-else-if="props.mode === EHeaterProgramMetaMode.NO_FROST" />
    <i
      v-else-if="props.mode === ECommonProgramMetaMode.OFF"
      class="pi pi-times-circle text-programming-stop-foreground"
    />
    <OnIcon v-else-if="props.mode === EOnProgramMetaMode.ON" />
  </div>
</template>
